<mat-checkbox
  [formControl]="formControl"
  *ngIf="agreement"
  (change)="onAgreementChange($event, agreement)"
>
  {{ agreement.label }}

  <ng-container *ngIf="agreement.termsUrls">
    <a [href]="agreement.termsUrls" xLinkColor="default">Terms and conditions</a>
  </ng-container>
</mat-checkbox>
